<script setup lang="ts">
import { ref } from 'vue';
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
} from 'devextreme-vue/data-grid';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { EntityListPage, bottoGridPaging, type EntityConfig, showError } from '@botto/core';
import CdpPageShell from '../components/CdpPageShell.vue';
import { contactsStore, fetchContactEvents, type Contact, type Postback } from '../api';

const { paging, pager } = bottoGridPaging();

const config: EntityConfig<Contact & { id: string }> = {
  title: 'Контакт',
  titlePlural: 'Контакты',
  keyExpr: 'id',
  popupWidth: 440,
  noDelete: true,
  columns: [
    { dataField: 'phone', caption: 'Телефон' },
    { dataField: 'message_id', caption: 'Message ID' },
    { dataField: 'created_at', caption: 'Создан', dataType: 'datetime', width: 180 },
  ],
  fields: [
    { dataField: 'phone', label: 'Телефон', required: true },
    { dataField: 'message_id', label: 'Message ID', required: true },
  ],
};

const eventsOpen = ref(false);
const eventsPhone = ref('');
const eventsLoading = ref(false);
const events = ref<Postback[]>([]);

async function showEvents(row: Contact & { id: string }) {
  eventsPhone.value = row.phone;
  eventsOpen.value = true;
  eventsLoading.value = true;
  events.value = [];
  try {
    events.value = await fetchContactEvents(row.phone);
  } catch (e) {
    showError(e);
  } finally {
    eventsLoading.value = false;
  }
}
</script>

<template>
  <CdpPageShell title="Контакты" :require-project="false">
    <p class="contacts-hint">
      Связка phone + message_id для матчинга событий CDP. SMS-модуль регистрирует контакт после отправки.
    </p>
    <EntityListPage :config="config" :store="contactsStore" :on-row-dbl-click="showEvents" />

    <DxPopup
      v-model:visible="eventsOpen"
      :title="`События: ${eventsPhone}`"
      :width="900"
      :height="520"
      :show-close-button="true"
    >
      <template #content>
        <DxDataGrid
          :data-source="events"
          :show-borders="true"
          :column-auto-width="true"
          :paging="paging"
          :pager="pager"
          height="400"
        >
          <DxScrolling mode="standard" />
          <DxColumn data-field="goal" caption="Goal" />
          <DxColumn data-field="phone" caption="Телефон" />
          <DxColumn data-field="click_id" caption="Click ID" />
          <DxColumn data-field="created_at" caption="Создано" data-type="datetime" width="180" />
        </DxDataGrid>
        <DxLoadPanel :visible="eventsLoading" :shading="true" />
      </template>
      <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="{ text: 'Закрыть', onClick: () => (eventsOpen = false) }" />
    </DxPopup>
  </CdpPageShell>
</template>

<style scoped>
.contacts-hint {
  margin: 0 0 8px;
  font-size: 0.875rem;
  color: var(--dx-color-text-secondary, #666);
}
</style>
